import React from 'react';
import { PageCard } from '@ui';
import { Body5, Container } from '@ui';
import { FlatButton } from '@ui/buttons';
import { ROUTES } from '@constants/routes';
import styled from 'styled-components';
import { logUserAction } from '@services/application';
import { useSearchParams } from 'react-router-dom';

const Background = styled.div`
  background-color: ${({ theme }) => theme.themeColors.appBackground};

  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  height: 100vh;
  max-width: 1000px;
  margin: 0 auto;
`;
const CaseStudiesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  padding: 16px 0 0 0;

  button {
    width: 200px;
  }
`;

export const SelectCaseStudy = () => {
  const [searchParams] = useSearchParams();

  const logStudy = (file) => {
    const email = searchParams.get('email');
    logUserAction({
      event_name: 'view_case_study',
      context: file,
      value: email || null,
    });
  };
  const onViewEquityFundCaseStudy = (e) => {
    const doc = 'Tornado Case Study - L_S Equity Fund.pdf';
    const url = ROUTES.pdfs + doc;
    logStudy(doc);
    window.open(url, '_blank');
  };

  const onViewInvestmentBankingCaseStudy = (e) => {
    const doc = 'Tornado Case Study - Investment Banking (Nov 24).pdf';
    const url = ROUTES.pdfs + doc;
    logStudy(doc);
    window.open(url, '_blank');
  };

  return (
    <Background>
      <PageCard>
        <Container>
          <Body5 bold>Select the case study you wish to view:</Body5>
          <CaseStudiesWrapper>
            <Container>
              <FlatButton onClick={onViewEquityFundCaseStudy}>Equity Fund</FlatButton>
            </Container>
            <Container>
              <FlatButton onClick={onViewInvestmentBankingCaseStudy}>Investment Banking</FlatButton>
            </Container>
          </CaseStudiesWrapper>
        </Container>
      </PageCard>
    </Background>
  );
};
